import InteractionDetails from "./interaction-details";
import InteractionMessages from "./interaction-messages";
import InteractionMetrics from "./interaction-metrics";
import InteractionTags from "./interaction-tags";
import { FunctionComponent, memo } from "react";
import { IProps } from "./interaction-content.types";
import "./interaction-content.scss";

/**
 * Display an interactions messages, tags, metrics etc.
 * @param props.agentId         Agent that handled the interaction.
 * @param props.interactionId   Identifier for the interaction.
 * @param props.interactionType Chat, email etc.
 * @param props.tags            Tags attached to the interaction
 * @param props.highlightedMessageId    The ID of highlighted message
 * @returns                     Interaction content and details.
 */
const InteractionContent: FunctionComponent<IProps> = ({
    agentId,
    highlightedMessageId,
    interactionId,
    interactionType,
    tags,
}) => {
    return (
        <div className="interaction-content interaction-pdf-content">
            <div className="interaction-content__text-container">
                <div className="interaction-content__text">
                    <InteractionMessages
                        interactionId={interactionId}
                        interactionType={interactionType}
                        highlightedMessageId={highlightedMessageId}
                    />
                </div>
            </div>
            <div className="interaction-content__details">
                <InteractionDetails agentId={agentId} interactionId={interactionId} />
                <InteractionMetrics interactionId={interactionId} />
                <InteractionTags tags={tags} interactionId={interactionId} />
            </div>
        </div>
    );
};

export default memo(InteractionContent);
